import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = `${process.env.REACT_APP_API_URL}/equipments`;

export const fetchEquipmentTotal = createAsyncThunk(
  'equipment/fetchTotal',
  async (_, { rejectWithValue, signal }) => {
    try {
      // Pagination reports the full count without downloading the full register.
      const response = await fetch(`${BASE_URL}?page=1&limit=1`, { signal });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Unable to load equipment total');
      const total = result.pagination?.total;
      if (!Number.isInteger(total) || total < 0) throw new Error('Equipment total is unavailable');
      return total;
    } catch (error) {
      return rejectWithValue(error.message || 'Unable to load equipment total');
    }
  }
);


// ============================================================
// 1. FETCH ALL EQUIPMENTS
// ============================================================
// Supports:
// search
// category
// location
// status
// riskLevel
// page
// limit
// ============================================================

export const fetchAllEquipments = createAsyncThunk(
  "equipment/fetchAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();

      if (params.search) {
        queryParams.append("search", params.search);
      }

      if (params.category) {
        queryParams.append("category", params.category);
      }

      if (params.location) {
        queryParams.append("location", params.location);
      }

      if (params.status) {
        queryParams.append("status", params.status);
      }

      if (params.riskLevel) {
        queryParams.append("riskLevel", params.riskLevel);
      }

      if (params.page) {
        queryParams.append("page", params.page);
      }

      if (params.limit) {
        queryParams.append("limit", params.limit);
      }

      const queryString = queryParams.toString();

      const url = queryString
        ? `${BASE_URL}?${queryString}`
        : BASE_URL;

      const response = await fetch(url);

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Failed to fetch equipments"
        );
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error.message ||
          "Network error occurred while fetching equipments"
      );
    }
  }
);


// ============================================================
// 2. FETCH SINGLE EQUIPMENT BY ID
// ============================================================

export const fetchEquipmentById = createAsyncThunk(
  "equipment/fetchById",
  async (equipmentId, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${BASE_URL}/${equipmentId}`
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Failed to fetch equipment"
        );
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error.message ||
          "Network error occurred while fetching equipment"
      );
    }
  }
);


// ============================================================
// 3. CREATE / ADD EQUIPMENT
// ============================================================

export const createEquipment = createAsyncThunk(
  "equipment/create",
  async (equipmentData, { rejectWithValue }) => {
    try {
      const response = await fetch(BASE_URL, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(equipmentData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Failed to add equipment"
        );
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error.message ||
          "Network error occurred while adding equipment"
      );
    }
  }
);
